export default __webpack_public_path__ + "static/media/logo.49431152.svg";